<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                用户列表
                <div v-if="list2Bool==true" class="back_btn" @click="list2Bool=false">
                    <Icon type="ios-arrow-back" />返回
                </div>
            </div>
            <template v-if="!list2Bool">
                <!-- table组件 -->
                <div class="my_table">
                    <Header class="my_title txt_l">
                        <span class='my_titleL'>
                            <Icon class="fw_900 " type="ios-list" size='30'/>     
                            筛选查询
                        </span>
                    
                    </Header>
                    <div class="my_search"> 
                        <Row class="search_row">  
                            <div  class="search_name">
                            查询:  
                            </div> 
                            <Col span="4" class="listIpt">
                                <Input :maxlength='20'  class='ipt   top13'  placeholder="UID/昵称" @keyup.enter.native="searchFun" v-model="search">
                                    <Button size="small"  @click='searchFun'  slot="append" icon="md-search"></Button>
                                </Input>
                            </Col>
                            
                        </Row>
                    </div>
                </div>
                <!-- table组件 -->
                <div class="my_table  ">
                    <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                            数据列表 
                        </span>
                        <div class="ct_rgt"> 
                            <div class="sta_btn " type="primary"   @click="exportData">导出数据</div>    
                        </div>
                    </Header>
                    <Table border :columns="columns1" :data="data1" ref='table'>
                        <!-- 安卓/ios -->
                        <template slot-scope="{ row }" slot="type">
                            <span v-if="row.type == 0"><Icon color="#19be6b" size="25" type="logo-android" /></span>
                            <span v-if="row.type == 1"><Icon color="#ed4014" size="25" type="logo-apple" /></span>
                        </template>
                        <!-- 按钮 -->
                        <template slot-scope="{ row }" slot="btn">
                            <Poptip trigger="hover" :title="row.surname" content="查看">
                                <Button class="padlr5" size="small"  @click="list2Bool=true;lookFun(row)"  type="info"    icon="md-search"  ></Button>
                            </Poptip>  
                            <Poptip trigger="hover" :title="row.surname" content="删除">
                                <Button class="padlr5" size="small"  @click="delM=true;delFun(row)"  type="error"      icon="md-close"></Button>
                            </Poptip>
                        </template>
                        
                    </Table>
                    <Footer>
                        <Page  :current.sync="page" :total="totalPage" :page-size='size' :page-size-opts='[5,10,20,50]'    @on-change='changepage' @on-page-size-change='pagesize'  show-total  show-sizer />
                    </Footer>
                </div>
            </template>  
            <template v-if="list2Bool">
                <feedback2 :row2="row"></feedback2>
            </template>  
        </div>
      
        <!-- 确认删除框 -->
        <Modal
            v-model="delM"
            title="提示"
            @on-ok="delOk"
            @on-cancel="delCancel"
            class-name="vertical-center-modal"
        >
            <p>确定删除{{name}}反馈吗? </p>         
        </Modal>
    </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import CryptoJS from 'crypto-js'
    import feedback2 from './feedback2'

    export default {
        name:'list',
        data () {
            return {
                route: null,
                row: null,
                list2Bool: false,
                delM: false,
                guid: null,
                name: null,
                search: '',


                columns1: [
                    {title:'UID',key:'number',align:'center',width:100},
                    {title:'用户昵称',key:'name',align:'center',width: 120},
                    {title:'反馈内容',key:'content',align:'center',render:(h,params) => {
                        return h('span',{
                            style:{},
                            domProps:{
                                title: params.row.content
                            }
                        },params.row.content)
                    },ellipsis: true},
                    {title:'登录设备',slot:'type',align:'center',width:100},
                    {title:'联系方式',key:'mobile',align:'center',width:150},
                    {title:'操作',key:'mobile',align:'center',width:150},
                    {title:'反馈时间',key:'createTime',align:'center',width:180},
                    {title:'操作',slot:'btn',align:'center',width:120,fixed: 'right'}
                ],
                data1: [],
                totalPage: 0,
                page: 1,
                size: 10,

            }
        },
        computed: {},
        components:{
            feedback2:feedback2
        },
        methods: {
            load(){
                let search = this.search.replace(/(^\s*)|(\s*$)/g, "");
                this.$myAjax.get('admin/service/admin/opinion/get/data?page='+this.page+'&size='+this.size+'&data='+search).then(res => {
                    let data = res.data.data;
                    this.page = data.pageNum;
                    this.size = data.pageSize;
                    this.totalPage = data.total;
                    this.data1 = data.list;
                })
            },
            nameFun(){

            },
            searchFun(){
                this.page = 1;
                this.size = 10;
                this.load();
            },
            lookFun(val){
                this.row = val;
            },
            delFun(val){
                this.name = val.name;
                this.guid  = val.guid;
            },
            delOk(){
                this.$myAjax.delete('admin/service/admin/opinion/delete?guid='+this.guid).then(res => {
                    this.load();
                })
            },
            delCancel(){
                this.delM = false;
            },
            changepage(index){
                this.load();
            },
            pagesize(index){
                this.page = 1;
                this.size = index;
                this.load();
            },
            // 清空
            clearFun(){
              
              this.load();
            },
        
           //导出数据
           //    导出
            exportData(){
                var that = this;
                that.$refs.table.exportCsv({
                    filename: '用户列表',
                    original: false
                });
               
            },

        },
        mounted: function(){   
            this.load();

        }
    }
</script>
<style scoped>
  
</style>



